var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirhug(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 78,
    viewBox: "0 0 208 204",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.889 99.205c0 33.5-27.126 60.658-60.589 60.658-33.462 0-60.59-27.158-60.59-60.658s27.128-60.658 60.59-60.658c33.463 0 60.589 27.157 60.589 60.658Z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.302 80.962a6.159 6.159 0 1 0-11.899 3.191l-2.405.646c-1.236-4.62 1.502-9.368 6.116-10.606 4.614-1.237 9.357 1.504 10.593 6.123l-2.405.646ZM123.788 73.927a6.16 6.16 0 0 0-7.221-4.876 6.166 6.166 0 0 0-4.871 7.23l-2.445.475c-.911-4.695 2.151-9.24 6.841-10.153 4.689-.912 9.229 2.154 10.14 6.848l-2.444.476ZM80.575 107.327c6.814.418 15.99-.406 25.896-2.601 9.905-2.194 18.572-5.323 24.573-8.58 3.009-1.632 5.282-3.262 6.71-4.773 1.464-1.549 1.819-2.724 1.639-3.54l2.431-.538c.452 2.048-.614 4.049-2.261 5.792-1.683 1.78-4.211 3.558-7.332 5.251-6.257 3.395-15.157 6.593-25.222 8.822-10.066 2.23-19.482 3.091-26.586 2.655-3.543-.217-6.584-.761-8.86-1.664-2.229-.884-4.038-2.248-4.49-4.296l2.43-.538c.18.815.998 1.731 2.977 2.516 1.932.767 4.68 1.285 8.095 1.494ZM61.64 120.42c-11.193 0-20.271 9.099-20.271 20.327 0 11.228 9.078 20.327 20.272 20.327h24.167a3.067 3.067 0 0 0 3.065-3.068 3.065 3.065 0 0 0-3.061-3.068H72.017v-2.493h22.411a3.067 3.067 0 0 0 3.065-3.069 3.066 3.066 0 0 0-3.061-3.068H75.465v-2.493h22.411a3.067 3.067 0 0 0 3.065-3.068 3.066 3.066 0 0 0-3.065-3.068H75.465v-2.493h18.101a3.067 3.067 0 0 0 3.065-3.069 3.067 3.067 0 0 0-3.065-3.068H63.828v-2.493h11.637a3.066 3.066 0 0 0 3.064-3.068 3.066 3.066 0 0 0-3.064-3.068v-2.493a5.558 5.558 0 0 1 5.555 5.561c0 1.134-.34 2.189-.922 3.068h13.468a5.558 5.558 0 0 1 5.555 5.561 5.544 5.544 0 0 1-.927 3.078 5.558 5.558 0 0 1 5.237 5.552 5.561 5.561 0 0 1-4.445 5.45c.628.901.997 1.997.997 3.179a5.558 5.558 0 0 1-5.555 5.562h-3.986c.582.879.921 1.934.921 3.068a5.558 5.558 0 0 1-5.555 5.561H61.641c-12.573 0-22.762-10.219-22.762-22.82 0-12.602 10.189-22.82 22.762-22.82h13.824v2.493H61.64Z",
    fill: "#262626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.621 120.439c-11.194 0-20.272 9.099-20.272 20.327 0 11.229 9.078 20.328 20.272 20.328H85.79a3.067 3.067 0 0 0 3.064-3.069 3.067 3.067 0 0 0-3.06-3.068H71.996v-2.493h22.411a3.067 3.067 0 0 0 3.065-3.068 3.066 3.066 0 0 0-3.06-3.068H75.444v-2.493h22.411a3.067 3.067 0 0 0 3.065-3.069 3.067 3.067 0 0 0-3.065-3.068h-22.41v-2.493h18.1a3.066 3.066 0 0 0 3.065-3.068 3.066 3.066 0 0 0-3.065-3.068H63.81v-2.493h11.636a3.067 3.067 0 0 0 3.065-3.069 3.067 3.067 0 0 0-3.065-3.068H61.621Z",
    fill: "url(#b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.322 176.496a3.096 3.096 0 0 1-1.941-3.833l26.561-86.49a6.001 6.001 0 0 1 7.711-3.905l.911.318a6 6 0 0 1 3.614 7.85L128.225 174.7a3.097 3.097 0 0 1-3.903 1.796Z",
    fill: "#CEECB5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M163.219 60.395a1.875 1.875 0 0 1 2.783.97c1.446 4.092 4.222 12.865 2.911 16.628-1.74 4.99-7.249 7.609-12.305 5.846-5.056-1.762-7.745-7.237-6.005-12.228 1.311-3.763 8.939-8.91 12.616-11.216Z",
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 60,
    width: 20,
    height: 25
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M163.227 60.39a1.876 1.876 0 0 1 2.783.97c1.446 4.093 4.222 12.866 2.911 16.629-1.74 4.991-7.249 7.609-12.305 5.846-5.056-1.762-7.745-7.237-6.005-12.228 1.311-3.763 8.939-8.91 12.616-11.216Z",
    fill: "#000"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.554 67.414a5.687 5.687 0 0 1-2.169-6.252l3.789-12.834 43.629 12.88-3.789 12.834a5.685 5.685 0 0 1-8.737 3.032l-.87-.614a8.81 8.81 0 0 0-5.454-1.61 8.81 8.81 0 0 1-5.453-1.61 8.81 8.81 0 0 0-5.454-1.61 8.81 8.81 0 0 1-5.454-1.61 8.807 8.807 0 0 0-5.453-1.61l-1.064.043a5.69 5.69 0 0 1-3.521-1.039Z",
    fill: "url(#d)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.117 120.422c11.194 0 20.272 9.099 20.272 20.327 0 11.228-9.078 20.327-20.272 20.327H121.95a3.067 3.067 0 0 1-3.065-3.068 3.065 3.065 0 0 1 3.061-3.068h13.795v-2.493H113.33a3.067 3.067 0 0 1-3.065-3.069 3.066 3.066 0 0 1 3.061-3.068H132.293v-2.493h-22.411a3.067 3.067 0 0 1-3.065-3.068 3.066 3.066 0 0 1 3.065-3.068H132.293v-2.493h-18.101a3.067 3.067 0 0 1-3.065-3.069 3.067 3.067 0 0 1 3.065-3.068h29.738v-2.493h-11.637a3.067 3.067 0 0 1-3.065-3.068 3.067 3.067 0 0 1 3.065-3.068v-2.493a5.558 5.558 0 0 0-5.555 5.561 5.54 5.54 0 0 0 .921 3.068h-13.467a5.558 5.558 0 0 0-5.555 5.561c0 1.138.341 2.196.927 3.078a5.558 5.558 0 0 0-5.237 5.552 5.561 5.561 0 0 0 4.445 5.45 5.534 5.534 0 0 0-.997 3.179 5.558 5.558 0 0 0 5.555 5.562h3.986a5.54 5.54 0 0 0-.921 3.068 5.558 5.558 0 0 0 5.555 5.561h24.167c12.573 0 22.762-10.219 22.762-22.82 0-12.602-10.189-22.82-22.762-22.82h-13.824v2.493h13.824Z",
    fill: "#262626"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M146.117 120.422c11.194 0 20.272 9.099 20.272 20.327 0 11.228-9.078 20.327-20.272 20.327H121.95a3.067 3.067 0 0 1-3.065-3.068 3.065 3.065 0 0 1 3.061-3.068h13.795v-2.493H113.33a3.067 3.067 0 0 1-3.065-3.069 3.066 3.066 0 0 1 3.061-3.068H132.293v-2.493h-22.411a3.067 3.067 0 0 1-3.065-3.068 3.066 3.066 0 0 1 3.065-3.068H132.293v-2.493h-18.101a3.067 3.067 0 0 1-3.065-3.069 3.067 3.067 0 0 1 3.065-3.068h29.738v-2.493h-11.637a3.067 3.067 0 0 1-3.065-3.068 3.067 3.067 0 0 1 3.065-3.068h13.824Z",
    fill: "url(#e)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 60.6581 -60.5893 0 102.3 99.205)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#F7CFDA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.20464 22.85206 -32.32953 11.60736 62.93 140.734)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#F7CFDA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-10.05632 22.82015 -32.28782 -14.2285 146.659 140.749)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651,
    stopColor: "#F7CFDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 154.442,
    y1: 60.582,
    x2: 171.25,
    y2: 65.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#F7CFDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirhug);
export default __webpack_public_path__ + "static/media/airhug.c2f73a76b9085c62e2569b19cb6caafa.svg";
export { ForwardRef as ReactComponent };